<template>
  <div class="details-component" v-if="permit">
    <div class="details-component__header">
      <h1>{{ $t('add_permit.edit_permit') }} </h1>
    </div>
    <div class="details-component__content content">
      <div class="content__cell">
        <table class="details-table">
          <tr class="details-table__row">
            <td class="details-table__col details-table__col_label">{{ $t('common.zone') }}</td>
            <td class="details-table__col" v-if="permit.product">
              <span v-for="zone in permit.product.zones" :key="zone.id">{{ zone.code }} </span>
            </td>
          </tr>
          <tr class="details-table__row" v-if="permit.partner">
            <td class="details-table__col details-table__col_label">{{ $t('common.issued_by') }}</td>
            <td class="details-table__col">{{ permit.partner.name }}</td>
          </tr>
        </table>
        <form class="form-edit">
          <fieldset class="form-edit__fieldset">
            <div class="form-edit__field parking-card-field"
              :class="{ 'form__field_error': errors.has('parkingCardNr') }" v-if="canUseCards()">
              <label for="parkingCardNr" class="form-edit__label remove-white-space">{{
    $t('add_permit.parking_card_id')
  }}</label>
              <div class="parkingCardNr-background">
                <input type="text" class="form-edit__input" name="parkingCardNr" id="parkingCardNr"
                  v-model="parkingCardNr" @keydown.stop.prevent="setCharacter($event); $refs.parkingCardNr.focus();"
                  @keyup.stop.prevent="setCaretPosition(caretPosition)" v-validate="'validParkingCardNr'"
                  :data-vv-as="$t('add_permit.parking_card_id')" data-vv-delay="1000" ref="parkingCardNr"
                  :disabled="permitChangeDisabled" />
                <div class="input-reproduction">
                  <span class="input-character"
                    :style="{ width: 'calc( (100% - ' + (8 * 5) + 'px) / ' + 9 + ')', marginRight: 5 + 'px' }"
                    v-for="number in maxCharactersInParkingCardNrInput"
                    @click="(number > parkingCardNr.split('').length ? setCaretPosition(parkingCardNr.split('').length + 1) : setCaretPosition(number)); $refs.parkingCardNr.focus();">
                    {{
    typeof parkingCardNr.split('')[number - 1] === 'undefined' ? '' : parkingCardNr.split('')[number -
      1]
  }}
                    <span class="input-cursor-down" v-if="number === caretPosition" v-show="animationShow"></span>
                  </span>
                </div>
              </div>
              <tooltip v-show="errors.has('parkingCardNr')" class="form-edit__validation">{{
    $t('errors.valid_card_field')
  }}
              </tooltip>
            </div>
            <!-- Vehicles -->
            <div class="form-edit__field"
              :class="{ 'form__field_error': errors.has('vehicleReg'), 'form__field_radiobuttons': hasVehicles }">

              <label for="vehicleReg" class="form-edit__label">{{ $tc('common.user_vehicle_reg', 'vehicleReg')
                }}</label>

              <div v-for="vehicle in vehicles.data" :id="'plate-' + vehicle.id"
                :class="vehicle.id === activePlate ? 'permit-edit-block active-border' : 'permit-edit-block'">
                <!-- edit permit row block -->
                <div :class="vehicle.id === selectedVehicle.id
    ? (vehicle.id === activePlate ? 'row-title' : 'row-title active-plate-bg')
    : 'row-title'" style="padding-top: 0">
                  <!-- edit icon -->
                  <div v-if="vehicle.id !== activePlate" class="edit-icon" @click="selectActivePlate(vehicle.id)" />

                  <!-- plate number + parking icon -->
                  <el-tag :id="'plate-' + vehicle.id" :key="vehicle.id" closable @click.native="selectVehicle(vehicle)"
                    :disable-transitions="false" @close.stop.prevent="removeVehicle(vehicle)"
                    :class="!vehicle.permitId ? vehicle.id === selectedVehicle.id ? 'el-tag--success' : '' : vehicle.id === selectedVehicle.id ? vehicle.permitId.length > 0 ? 'el-tag--success el-tag--permit' : 'el-tag--success' : vehicle.permitId.length > 0 ? 'el-tag--permit' : ''"
                    role="select vehicle">
                    <div style="flex-direction: column;">
                      <span
                        :class="vehicle.comment && vehicle.id !== activePlate ? 'vehicle-reg half' : 'vehicle-reg full'">{{
    vehicle.vehicleReg }}</span>
                      <span v-if="vehicle.comment && vehicle.id !== activePlate" class="vehicle-comment">{{
    vehicle.comment }}</span>
                    </div>
                  </el-tag>
                </div>

                <!-- comment edit form -->
                <div :id="'comment-block-' + vehicle.id" :ref="'comment-block-' + vehicle.id"
                  :class="vehicle.id === activePlate ? 'active-edit' : 'hidden-edit'">
                  <input class="vehicleInput-comment" :ref="`comment-${vehicle.id}`"
                    :placeholder="$t('parking.comment')" :value="vehicle.comment" />
                  <!-- save/cancel buttons -->
                  <div class="form-edit__buttons buttonset">
                    <div class="buttonset__button btn btn--secondary btn--small" @click="selectActivePlate(0)">
                      {{ $t('common.cancel') }}
                    </div>
                    <button type="submit" class="buttonset__button btn btn--main btn--small"
                      :ref="`confirm-btn-${vehicle.id}`" @click.prevent.stop="saveComment(vehicle.id)">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>

              </div>


              <!-- new plate number form -->

              <el-input id="vehicleReg" name="vehicleReg" class="vehicleInput-toggle" v-model="form.vehicleReg"
                v-validate="'max:15'" ref="vehicleInput" @keyup.enter.native="toggleInput('vehicleInput');"
                @keydown.native="stopInputAtDashAndSpace" v-if="!vehicleInputDisabled">
                <el-button
                  :class="{ 'vehicleInput-toggle': vehicleInputDisabled, 'on-click-trigger-submit3': !vehicleInputDisabled }"
                  slot="append">
                  {{ $t('common.ok') }}
                </el-button>
              </el-input>

              <!-- add plate number button -->
              <el-button class="vehicle-input"
                :class="{ 'vehicleInput-toggle': vehicleInputDisabled, 'on-click-trigger-submit': !vehicleInputDisabled }"
                v-if="vehicleInputDisabled && !permitChangeDisabled">
                {{ '+ ' + $t('add_permit.add_car') }}
                <i class="el-icon-edit el-icon-right"
                  :class="{ 'vehicleInput-toggle': vehicleInputDisabled, 'on-click-trigger-submit': !vehicleInputDisabled }"></i>
              </el-button>
              <el-input class="vehicleInput-comment-new vehicleInput-toggle" name="vehicleComment" ref="vehicleComment"
                :placeholder="$t('parking.comment')" v-if="!vehicleInputDisabled" v-model="form.vehicleComment" />
              <tooltip v-show="errors.has('vehicleReg:max')" class="form-edit__validation to-bottom">
                {{ $tc('errors.field_max', 1, { max: 12, have: form.vehicleReg ? form.vehicleReg.length : '' }) }}
              </tooltip>
            </div>
          </fieldset>

          <!--  Discard|Save buttons -->
          <div class="form-edit__buttons buttonset">
            <router-link :to="{ name: 'user-permit', params: { id: $route.params.id } }"
              class="buttonset__button btn btn--secondary">
              {{ $t('common.discard') }}
            </router-link>
            <button type="submit" class="buttonset__button btn btn--main" @click.prevent.stop="onSubmit()">
              {{ $t('common.save') }}
            </button>
          </div>
        </form>
      </div>
      <WarningModal v-if="showWarningModal" @close="closeWarningModal">
        <h1 slot="header">{{ userWarningHeader }}</h1>
        <p slot="body">{{ userWarningBody }}</p>
      </WarningModal>
    </div>
  </div>

</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import * as mTypes from 'store/mutation-types';
import Tooltip from 'common/Tooltip';
import ConfirmationModal from 'common/ConfirmationModal';
import WarningModal from 'common/WarningModal';
import { sanitizeVehicleRegNumber } from '../../utils';

export default {
  components: {
    Tooltip,
    ConfirmationModal,
    WarningModal,
  },
  data() {
    return {
      form: {
        parkingCardNr: '',
        vehicleReg: '',
        vehicleComment: ''
      },
      selectedVehicle: {
        id: null,
        vehicleReg: '',
      },
      activePlate: null,
      showConfirmationModal: false,
      showWarningModal: false,
      userWarningBody: null,
      userWarningHeader: null,
      animationShow: false,
      caretPosition: 1,
      maxCharactersInParkingCardNrInput: 9,
      parkingCardNr: '',
      vehicleInputDisabled: true,
      setLastVehicle: false,
      permitChangeDisabled: false,
    };
  },
  mounted() {
    this.fetchAllData();
  },
  computed: {
    ...mapGetters({
      permitError: 'permits/permit/error',
      permit: 'permits/permit/permit',
      user: 'user/user/user',
      users: 'users/user/user',
      vehicles: 'users/vehicles/vehicles',
    }),
    selectedUser() {
      return this.user.data && this.user.data.selectedRole ? this.user.data.selectedRole.id : null;
    },
    hasVehicles() {
      return this.vehicles.data && this.vehicles.data.length > 0;
    },
  },
  watch: {
    $route: 'fetchAllData',
  },
  created() {
    this.$store.commit(`permits/permit/${mTypes.CLEAR_STATE}`);
    this.$store.commit(`users/vehicles/${mTypes.CLEAR_STATE}`);
    this.resetValidators();
    this.createValidators();
    this.animation = setInterval(() => this.animateCursor(), 400);
    document.removeEventListener('click', window.eventListenerForEditViewPermit);
    window.eventListenerForEditViewPermit = this.handleInput;
    document.addEventListener('click', this.handleInput, false);
  },
  methods: {
    toggleInput(buttonRef) {
      this.callSubmitIfInputIsEnabled(buttonRef);
      this[`${buttonRef}Disabled`] = !this[`${buttonRef}Disabled`];
    },
    callSubmitIfInputIsEnabled(buttonRef) {
      if (!this[`${buttonRef}Disabled`]) {
        this.onSubmit();
      }
    },
    handleInput(event) {
      if (event.target && (event.target.classList.contains('on-click-trigger-submit3') || event.target.parentElement.classList.contains('on-click-trigger-submit3'))) {
        if (this.form.vehicleReg !== '') {
          this.saveVehicle({
            vehicle_reg: sanitizeVehicleRegNumber(this.form.vehicleReg).toUpperCase(),
            vehicleComment: this.form.vehicleComment,
            userId: this.selectedUser
          });
        }
        this.form.vehicleReg = '';
        this.vehicleInputDisabled = true;
      }
      let buttonRef = false;
      this.vehicleInputDisabled = true;
      if (event.target && (event.target.classList.contains('vehicleInput-toggle') || event.target.parentElement.classList.contains('vehicleInput-toggle'))) {
        buttonRef = 'vehicleInput';
      }
      if (buttonRef) {
        this[`${buttonRef}Disabled`] = false;
      }
    },
    focusInput(buttonRef) {
      if (!this[`${buttonRef}Disabled`]) {
        this.$nextTick(() => this.$refs[buttonRef].$refs.input.focus());
      }
    },
    stopInputAtDashAndSpace(event) {
      if (event.key === '-' || event.key === ' ') {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    animateCursor() {
      if (this.$refs.parkingCardNr === document.activeElement) {
        this.animationShow = !this.animationShow;
      } else {
        this.animationShow = false;
      }
    },
    saveVehicle(vehicle) {
      this.$validator.validateAll()
        .then((success) => {
          if (success) {
            if (vehicle.id === undefined) {
              this.$store.dispatch('permits/permit/saveNewVehicle', vehicle)
                .then((response) => {
                  this.selectedVehicle.id = JSON.parse(response.bodyText).data.id
                  this.fetchVehiclePlateNumbers()
                }).catch((error) => {
                  const { message } = error.body;
                  this.showWarningModal = true;
                  this.userWarningHeader = this.$t('common.warning');
                  this.userWarningBody = this.$t(`errors.${message}`);
                });
            } else {
              this.$store.dispatch('users/vehicles/saveVehicle', vehicle).then((response) => {
                this.selectedVehicle = JSON.parse(response.bodyText);
              });
            }
          }
        });
    },
    setCharacter(event) {
      const pos = this.caretPosition;
      const arr = this.parkingCardNr.split('');
      if (event.key === 'Backspace' || event.keyCode === 8) {
        arr.splice(pos - 1, 1);
        if (pos <= 1) {
          this.setCaretPosition(1);
        } else {
          this.setCaretPosition(pos - 1);
        }
      } else if (event.key === 'Delete' || event.key === 'Del' || event.keyCode === 46) {
        if (pos <= 1) {
          this.setCaretPosition(1);
          arr.splice(pos - 1, 1);
        } else if (pos >= arr.length) {
          arr.splice(pos - 1, 1);
        }
        arr.splice(pos, 1);
      } else if (event.key === 'ArrowLeft' || event.key === 'Left' || event.keyCode === 37) {
        if (pos <= 1) {
          this.caretPosition = 1;
        } else if (pos > this.maxCharactersInParkingCardNrInput) {
          this.setCaretPosition(this.maxCharactersInParkingCardNrInput);
        } else if (pos <= arr.length + 1) {
          this.setCaretPosition(pos - 1);
        }
      } else if (event.key === 'ArrowRight' || event.key === 'Right' || event.keyCode === 39) {
        if (pos < 1) {
          this.setCaretPosition(1);
        } else if (pos >= this.maxCharactersInParkingCardNrInput) {
          this.setCaretPosition(this.maxCharactersInParkingCardNrInput);
        } else if (pos <= arr.length) {
          this.setCaretPosition(pos + 1);
        }
      } else if (event.key === 'Enter' || event.keyCode === 13) {
        this.$refs.parkingCardNr.blur();
      } else if (typeof event.key === 'string' && event.key.split('').length === 1) {
        arr.splice(pos - 1, 1);
        arr.splice(pos - 1, 0, event.key);
        if (pos < 1) {
          this.setCaretPosition(1);
        } else if (pos >= this.maxCharactersInParkingCardNrInput) {
          this.setCaretPosition(this.maxCharactersInParkingCardNrInput);
        } else {
          this.setCaretPosition(pos + 1);
        }
      } else if (event.keyCode === 229) {
        if (pos < 1) {
          this.setCaretPosition(1);
        } else if (pos >= this.maxCharactersInParkingCardNrInput) {
          this.setCaretPosition(this.maxCharactersInParkingCardNrInput);
        } else {
          this.setCaretPosition(pos + 1);
        }
      }
      this.parkingCardNr = arr.join('');
      this.form.parkingCardNr = this.parkingCardNr;
      this.$refs.parkingCardNr.focus();
    },
    setCaretPosition(pos) {
      const el = this.$refs.parkingCardNr;
      if (pos <= 1) {
        this.caretPosition = 1;
        el.selectionStart = 0;
        el.selectionEnd = 1;
      } else if (pos >= this.maxCharactersInParkingCardNrInput) {
        this.caretPosition = this.maxCharactersInParkingCardNrInput;
        el.selectionStart = this.maxCharactersInParkingCardNrInput - 1;
        el.selectionEnd = this.maxCharactersInParkingCardNrInput;
      } else {
        this.caretPosition = pos;
        el.selectionStart = pos - 1;
        el.selectionEnd = pos;
      }
    },
    preselectVehicle() {
      if (this.permit.vehicle) {
        this.selectedVehicle = this.permit.vehicle;
      }
    },
    checkingNumberForPermit() {
      if (!this.users.vehicles) {
        return
      }
      this.vehicles.data.forEach((vehicle) => {
        this.users.vehicles.forEach((item) => {
          if (vehicle.id === item.id) {
            vehicle.permitId = item.permitId;
          }
        });
      });
    },
    fetchVehiclePlateNumbers() {
      if (this.selectedUser) {
        this.$store.dispatch('users/vehicles/fetch', { id: this.selectedUser, user: this.user })
          .then(() => {
            this.fetchUsersVehicles();
            this.checkingNumberForPermit();
            this.preselectVehicle();
          });
      }
    },
    fetchUsersVehicles() {
      this.$store.dispatch('users/user/fetch', { id: this.selectedUser, user: this.user })
        .then(() => {
          this.vehicles.data = this.users.vehicles;
        });
    },
    fetchAllData() {
      if (this.$route.params.id) {
        this.fetchVehiclePlateNumbers();
        this.fetchPermit();
      } else {
        this.$store.commit(`permits/permit/${mTypes.CLEAR_STATE}`);
        this.$store.commit(`users/vehicles/${mTypes.CLEAR_STATE}`);
      }
    },
    checkedDateForPermitChangeDisabled() {
      if (moment().isAfter(moment(this.permit.expirationDate, 'DD.MM.YYYY'), 'day')) {
        this.permitChangeDisabled = true;
      } else {
        this.permitChangeDisabled = false;
      }
    },
    fetchPermit() {
      if (this.user.data) {
        this.$store.dispatch('permits/permit/fetch', { id: this.$route.params.id, user: this.user }).then(() => {
          this.form.parkingCardNr = this.permit.parkingCardNr;
          this.parkingCardNr = this.permit.parkingCardNr ? this.permit.parkingCardNr : '';
          if (this.permit.vehicle) {
            this.selectedVehicle = this.permit.vehicle;
          } else {
            this.selectedVehicle = { id: null, vehicleReg: '' };
          }
          this.checkedDateForPermitChangeDisabled();
          window.scrollTo(0, 146);
        });
      }
    },
    onSubmit() {
      this.$validator.validateAll()
        .then((success) => {
          if (success) {
            if (this.selectedVehicle && this.selectedVehicle.id && this.form.vehicleReg === '') {
              this.form.vehicleId = this.selectedVehicle.id;
            } else {
              this.form.vehicleId = null;
            }
            if (!this.form.parkingCardNr || this.form.parkingCardNr === '' || !this.canUseCards()) {
              this.form.parkingCardNr = null;
            }
            this.form.userId = this.selectedUser;
            this.form.id = this.permit.id;

            if (!this.form.vehicleId) {
              this.$validator.validateAll()
                .then((success) => {
                  if (success) {
                    this.$store.dispatch('permits/permit/saveNewVehicle',
                      {
                        vehicle_reg: sanitizeVehicleRegNumber(this.form.vehicleReg).toUpperCase(),
                        vehicleComment: this.form.vehicleComment,
                        userId: this.selectedUser,
                      }
                    )
                      .then((response) => {
                        this.form.vehicleId = JSON.parse(response.bodyText).data.id
                        this.savePermit();
                      }).catch((error) => {
                        const { message } = error.body;
                        this.showWarningModal = true;
                        this.userWarningHeader = this.$t('common.warning');
                        this.userWarningBody = this.$t(`errors.${message}`);
                      })
                  }
                });
            } else {
              this.savePermit()
            }
          }
        });
    },
    savePermit() {
      this.$store.dispatch('permits/permit/savePermit', { user: this.user, permit: this.form })
        .then(() => {
          if (!this.permitError) {
            this.form = {
              parkingCardNr: '',
              vehicleReg: '',
            };
            this.$router.push({ name: 'user-permit', params: { id: this.permit.id } });
            window.scrollTo(0, 0);
          }
        });
    },
    closeWarningModal() {
      this.showWarningModal = false;
    },
    resetValidators() {
      this.$validator.remove('validParkingCardNr');
      this.$validator.clean();
    },
    createValidators() {
      this.createParkingCardValidator();
    },
    createParkingCardValidator() {
      this.$validator.extend('validParkingCardNr', {
        getMessage: field => `The ${field} value is not valid parking card number.`,
        validate: (value) => {
          if (value === '') {
            return true;
          }
          const input = value.toString();
          const checkNr = input[input.length - 1];
          let eventSum = 0;
          let oddSum = 0;
          let i = 0;
          while (i < input.length - 1) {
            const d = parseInt(input[i], 16);
            if (i % 2 === 0) {
              oddSum += d;
            } else {
              eventSum += d;
            }
            i += 1;
          }
          const totalSum = (eventSum * 3) + oddSum;
          const nextTen = (Math.ceil(totalSum / 10)) * 10;
          const calculatedCheckNr = nextTen - totalSum;
          return calculatedCheckNr.toString() === checkNr;
        },
      });
    },
    clearVehicle() {
      this.selectedVehicle = null;
    },
    removeVehicle(vehicle) {
      if (!this.permitChangeDisabled) {
        this.$validator.validateAll()
          .then((success) => {
            if (success) {
              if (vehicle.id === this.selectedVehicle.id) {
                this.selectedVehicle = this.vehicles.data[0];
              }
              this.$store.dispatch('users/vehicles/delete', { id: vehicle.id, user: this.user })
                .then(() => {
                  if (!this.vehicleError) {
                    const index = this.vehicles.data.findIndex(obj => obj.id === vehicle.id);
                    this.$delete(this.vehicles.data, index);
                  } else {
                    this.showWarningModal = true;
                    this.userWarningHeader = this.$t('common.warning');
                    this.userWarningBody = this.$t(`errors.${this.vehicleError.body.error}`);
                  }
                });
              this.$store.commit(`users/vehicles/${mTypes.DATA_ERROR}`, null);
            }
          });
      }
    },
    selectVehicle(vehicle) {
      this.selectedVehicle = vehicle;
    },
    canUseCards() {
      if (this.permit.product) {
        return this.permit.product.canUseCards;
      }
      return false;
    },
    selectActivePlate(plateId) {
      this.activePlate = plateId
    },
    saveComment(vehicleId) {
      try {
        this.$refs[`confirm-btn-${vehicleId}`][0].disabled = true
        this.$store.dispatch('permits/permit/updateVehicle', {
          vehicleId: vehicleId,
          vehicleComment: this.$refs[`comment-${vehicleId}`][0].value,
          userId: this.selectedUser
        }).then(() => {
          this.fetchVehiclePlateNumbers();
          this.$refs[`confirm-btn-${vehicleId}`][0].disabled = false
          this.activePlate = ''
        })
      } catch (e) {
        console.log('Vehicle comment update error', e)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/blocks/permit-edit.scss";
@import '~styles/blocks/details.scss';

.form-edit {
  &__selectbox {
    width: 200px;
  }

  .vehicle-remove-button i {
    color: $brand-orange;
  }

  .add-vehicle {
    width: 100%;
    font-size: 12px;

    ::placeholder {
      font-size: 12px;
      padding: 15px 0 0 0;
      opacity: 0.4;
      padding: 10px 0;
      font-weight: 700;
    }

    &--btn-plus {
      float: right;
      position: relative;
      bottom: 26px;
      border: none;
      background: none;
      font-size: 17px;
      right: 4px;
      color: $brand-blue;
      cursor: pointer;
    }
  }
}

.details-table {
  &__row {
    @media screen and (max-width: 760px) {
      height: auto;
    }
  }

  &__col {
    @media screen and (max-width: 760px) {
      padding-top: 7px;
    }
  }
}

.form-edit {

  .vehicleInput-comment-new {
    margin-top: 4px;
  }

  &__fieldset {
    border: 0;
  }

  &__field,
  &__field_radiobuttons {
    @media screen and (max-width: 620px) {
      margin-top: 0;
    }
  }

  &__label.remove-white-space {
    @media screen and (max-width: 760px) {
      min-height: 0;
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &__field {
    @media screen and (max-width: 760px) {
      padding-top: 7px;
    }

    .parkingCardNr-background {
      position: relative;
      width: 300px;

      @media screen and (max-width: 760px) {
        width: 100%;
      }

      &:before {

        /*@media screen and (max-width: 760px) {
          content: "";
          position: absolute;
          right: auto;
          bottom: 0;
          left: -5px;
          width: calc(100% + 5px);
          height: 70%;
          background: repeating-linear-gradient(90deg, $grey-five, $grey-five 20px, transparent 10px, transparent 25px);
        }*/
      }

    }

    #parkingCardNr {
      background: transparent !important;
      bottom: 0;
      right: 0;
      position: absolute;
      width: 0;
      height: 0;
      font-size: 18px;
      text-align: left;
      background-color: transparent;
      letter-spacing: 15px;
      z-index: 1;
      color: transparent;

      &::-moz-selection {
        color: black;
        background: red;
      }

      &::selection {
        color: black;
        background: red;
      }

    }

    .input-reproduction {
      z-index: 20;
      padding-top: 16px;
      width: 100%;
      max-width: 300px;
      height: 100%;
      white-space: nowrap;

      .input-character {
        position: relative;
        display: inline-block;
        background: $grey-five;
        margin-right: 5px;
        width: 20px;
        font-size: 18px;
        height: 25px;
        text-align: center;
        line-height: 25px;
        font-weight: 700;
        vertical-align: top;
        cursor: text;
      }

      .input-cursor-down {
        position: absolute;
        bottom: 0;
        right: 0;
        height: 100%;
        width: 100%;
        border-bottom: 1px solid black;
        overflow: hidden;
      }
    }
  }

  .el-tag {
    &.el-tag--success {
      background-color: $brand-green;
      border: 1px solid $brand-green;
      color: white;

      /deep/ .el-tag__close {
        color: white;
      }

      &.el-tag--permit /deep/ .el-tag__close {
        &::before {
          background: url('~icons/number-permit.svg') center/contain no-repeat;
        }
      }
    }

    &.el-tag--permit /deep/ .el-tag__close {
      width: 30px;
      height: 100%;

      &::before {
        content: '';
        background: url('~icons/number-permit-black.svg') center/contain no-repeat;
        height: 100%;
      }
    }
  }
}
</style>

<style lang="scss">
@import '~styles/app.scss';

.form-edit {

  &__field {

    .el-input input {
      text-transform: uppercase;
    }

    .el-input {
      position: relative;
    }

    .el-button {
      vertical-align: middle;
    }

    .permit-edit-block {
      &.active-border {
        padding-top: 6px;
      }
    }


    .row-title {
      .el-tag {
        display: flex;
        justify-content: space-between;
        background-color: #f5f7fa;
        border: 0;
        margin: 0 5px 0 10px !important;
        color: #000;
        cursor: pointer;

        @media screen and (max-width: 520px) {
          padding: 0 20px 0 15px;
          height: 60px;
          line-height: 60px;
          width: 100%;
          font-size: large;
        }

        &__close {
          color: #000;
          line-height: $plate-row-h;

          @media screen and (max-width: 520px) {
            font-size: large;
            float: right;
            line-height: 60px;
          }
        }

        &__close:hover {
          background-color: transparent;
        }

        span {
          align-content: space-around;

          &.vehicle-reg {
            &.full {
              height: $plate-row-h;
              line-height: $plate-row-h;
            }

            &.half {
              padding-top: 5px;
              height: $plate-row-h-sm;
              line-height: $plate-row-h-sm;
            }
          }
        }

      }

      .el-tag:nth-last-child(3) {
        margin-right: -1px;
      }

      .el-input {
        max-width: 200px;

        @media screen and (max-width: 520px) {
          max-width: 100%;
        }

        input {
          @media screen and (max-width: 520px) {
            height: 60px;
          }
        }
      }

      .vehicleInput-toggle {
        margin: 2px;

        @media screen and (max-width: 520px) {
          font-size: large;
          height: 60px;
        }
      }

    }

    .radiobuttons>.el-button {
      position: relative;
      padding: 10px 69px 10px 15px;
      border-color: #d8dce5;
      height: auto;
      max-width: 250px;

      @media screen and (max-width: 520px) {
        font-size: large;
        height: 60px;
        max-width: none;
        width: 100%;
      }

      span {
        white-space: pre-line;
        line-height: 20px;

        i {
          position: absolute;
          right: 0;
          top: -2px;
          height: 100%;
          width: 54px;
          border-left: 1px solid #d8dce5;
          margin-left: 15px;
          vertical-align: top;
          background-color: #f5f7fa;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;

        }

        i:before {
          position: absolute;
          right: 50%;
          top: 50%;
          transform: translate(50%, -50%);
          color: #97a8be;

        }

      }

    }

  }

}

.tooltip {
  top: 50% !important;
  right: auto !important;
  left: 50px !important;
  z-index: 2000;
  transform: translateY(-50%);
  max-height: none;

  &__content {

    @media screen and (max-width: 1000px) {
      max-height: none;
      height: auto;
      white-space: pre-wrap;
      max-width: 150px;

    }

  }

}

.tooltip.to-bottom {
  top: auto;
  bottom: 11px;
  transform: none;

}

.buttonset {
  margin-right: 10px;

  @media screen and (max-width: 520px) {
    width: 100%;
  }

  .buttonset__button {
    @media screen and (max-width: 520px) {
      font-size: 18px;
      min-width: 110px;
      max-height: 50px;
      width: 42%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/end-user/EditPermit.vue